// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1swQK","approved":"Status_approved__kGleS","rejected":"Status_rejected__1FkAC","expired":"Status_expired__pae6R","label":"Status_label__2fXj2"};